import { format } from "date-fns";

export const sqlToDate = (date: string) => new Date(date);

export const dateToDisplay = (date: Date) => format(date,"dd/MM/yyyy");

export const sqlToDisplay = (date: string) => dateToDisplay(new Date(sqlToDate(date)));
